"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyStatus = void 0;
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVA"] = "ACTIVA";
    CompanyStatus["EN_RENOVACION"] = "EN RENOVACION";
    CompanyStatus["NO_RENOVADA"] = "NO RENOVADA";
    CompanyStatus["SUSPENDIDA"] = "SUSPENDIDA";
    CompanyStatus["CANCELADA"] = "CANCELADA";
    CompanyStatus["NO_ASIGNADA"] = "NO ASIGNADA";
})(CompanyStatus || (exports.CompanyStatus = CompanyStatus = {}));
//# sourceMappingURL=company-status.js.map